<template>
	<div class="contentbox">
		<ul class="tabs-ul-list">
			<li v-for="(item, index) in tabName" :key="index">
				<a :class="item.value === selectaVal ? 'active' : ''" @click="tabClick(item.value,item.name)">{{item.name}}</a>
			</li>
		</ul>
		<div class="tabs-ul-con" style="padding-top: 30px;">
			<!-- <router-view></router-view> -->
			<dp-recharge-gear :menuPage="'app'" v-if="selectaVal==1"></dp-recharge-gear>
			<dp-recharge-plan :menuPage="'app'" v-if="selectaVal==2"></dp-recharge-plan>
			<wb-recharge-template :menuPage="'app'" v-if="selectaVal==3"></wb-recharge-template>
		</div>
		<!--<agent-pop :visible.sync="isShowDialogAgent"></agent-pop>-->
	</div>
</template>
<script>
    // import AgentPop from '@/components/AgentPop'
    import DpRechargeGear from '@/views/wb/app/DpRechargeGear'
    import DpRechargePlan from '@/views/wb/app/DpRechargePlan'
    import WbRechargeTemplate from '@/views/wb/app/WbRechargeTemplate'
    export default {
        components: {
            // AgentPop,
            DpRechargeGear,
            DpRechargePlan,
            WbRechargeTemplate
        },
        data() {
            return {
                tabName: [
                    {
                        value: 1,
                        name: '创建充值档位'
                    },
					{
                        value: 2,
                        name: '充值方案配置'
                    },
                    {
                        value: 3,
                        name: '新增充值模板'
                    }
                ],
                selectaVal:1,
                isShowDialogAgent:true,
                platform: localStorage.getItem('platform')
            }
        },
        computed: {},
        watch: {
        },
        created(){
            if(JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
                this.isShowDialogAgent = false
            } else {
                this.isShowDialogAgent = true
            }
        },
        mounted: function() {
            if (localStorage.getItem('platform') == 'wb-dp') {
                this.tabName = [
                    {
                        value: 1,
                        name: '创建充值档位'
                    },
                    {
                        value: 2,
                        name: '充值方案配置'
                    },
                    {
                        value: 3,
                        name: '新增充值模板'
                    }
                ]   
			} else {
                this.tabName = [
                    {
                        value: 1,
                        name: '创建充值档位'
                    },
                    {
                        value: 2,
                        name: '充值方案配置'
                    }
                ]
            }
            console.log('充值组件', this.$route, this.platform)
        },
        methods: {
            tabClick (value, name) {
                // this.$router.push({ path:  path})
                this.selectaVal = value
                console.log(name)
            }
        }
    }
</script>
<style lang="sass">

</style>
